import { CryptoService } from "../../base-services/crypto.service";

export class TableContextMenu {
    Name: string = null;
    Action: string = null;
    Label: string = null;

    LoadItems(data: any, userRightsModelName: string) {
        let items: TableContextMenu[] = [];
        const encrypted = sessionStorage.getItem('yt-user-rights');
        let userRights;

        if(encrypted){
        try{
            userRights = CryptoService.Decrypt(encrypted);
        }catch(e){
            console.error('Decription failed:',e)
            }
        }

        if (data) {
            data.forEach(dataItem => {
                if (
                    userRights &&
                    userRights.Values[userRightsModelName] &&
                    userRights.Values[userRightsModelName][dataItem.Action]
                ) {
                    let item = new TableContextMenu();
                    item.Name = dataItem.Name;
                    item.Action = dataItem.Action;
                    item.Label = dataItem.Label;
                    items.push(item);         
                }
            });
        }
    
        return items;
    }
    
}